export default __webpack_public_path__ + "static/media/imageNotFound.3196dcd1.svg";